import { saveAs } from 'file-saver';

const exportHTMLToExcel = (htmlContent, fileName) => {
    // Wrap the HTML content in a full HTML document structure
    const fullHTML = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>Export HTML</title>
      </head>
      <body>
        ${htmlContent}
      </body>
    </html>
  `;

    // Convert the HTML string to a Blob
    const blob = new Blob([fullHTML], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });

    // Trigger the download using file-saver
    saveAs(blob, `${fileName}.xls`);
};

export default exportHTMLToExcel;
